import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { editRM, getRMsList } from '../../redux-store/actions/userManagement';
import { newRmType, RmsType, addRmDetails } from '../../redux-store/types/api-types';
import { ColumnType } from '../DataTable';
import UserMgmtListPage, {
  AccessHeader,
  NameLinkCell,
  buildAccessColumn,
  buildActionsColumn,
  formatPhone,
  formatUserName,
  matchesUserSearch,
} from './UserMgmtListPage';

export { AccessHeader };

export default function RelationshipManagers(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <UserMgmtListPage<RmsType>
      loadData={async () => {
        const res = (await dispatch(getRMsList())) as unknown as newRmType;
        return res?.rms || [];
      }}
      searchPlaceholder="Search for RMs"
      inviteLabel="Invite RM"
      onInvite={() => history.push('invite-rm-details')}
      filterRow={(row, q) =>
        matchesUserSearch(q, [
          formatUserName(row.user),
          row.user?.email,
          `${row.user?.countryCode || ''}${row.user?.phone || ''}`,
          row.empCode,
        ])
      }
      getColumns={({ onToggleAccess }) => {
        const columns: ColumnType[] = [
          {
            header: 'RM Name',
            align: 'left',
            headerAlign: 'left',
            renderCell: (row: RmsType) => (
              <NameLinkCell
                label={formatUserName(row.user)}
                to={{ pathname: 'relationship-manager-details', state: { rmId: row.id } }}
              />
            ),
          },
          {
            header: 'Email Id',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: RmsType) => row.user?.email || 'N/A',
          },
          {
            header: 'Mobile number',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: RmsType) => formatPhone(row.user),
          },
          {
            header: 'EMP Code',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: RmsType) => row.empCode || 'N/A',
          },
          buildAccessColumn(onToggleAccess),
          buildActionsColumn((row: RmsType) => [
            {
              label: 'View RM details',
              icon: '/images/rm.svg',
              to: { pathname: 'relationship-manager-details', state: { rmId: row.id } },
            },
            {
              label: 'View SRMs',
              icon: '/images/srm.svg',
              to: { pathname: 'srms', state: { rmId: row.id } },
            },
          ]),
        ];
        return columns;
      }}
      onAccessChange={async (row, nextActive) =>
        (await dispatch(
          editRM(row.id as number, { ...(row as unknown as addRmDetails), isActive: nextActive })
        )) as unknown as RmsType
      }
    />
  );
}
